import React from "react";
import Color from 'color';
import { ReactComponent as Kitten } from "@/assets/frames/thirdCat.svg";
import { ReactComponent as Love } from "@/assets/frames/third.svg";
import {Box} from "@mui/material";

export const KittenLoveFrame = ({ color, children }) => {
    return (
        <Box style={{ display: 'flex', cursor:'pointer', minWidth: '100px', minHeight: '80px'}}>
            <div style={{
                position: 'relative',
                background: `rgba(${Color(color).darken(0.8).rgb().array().join(', ')}, 0.9)`,
                color: color,
                width: '100%',
                height: '100%',
                minHeight: '80px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '13px'
            }}>
                <div>
                    { children }
                </div>
                <Kitten style={{
                    position: 'absolute',
                    bottom: '100%',
                    right: 0,
                }}/>
                <Love style={{
                    position: 'absolute',
                    top: -15,
                    right: -30
                }}/>
            </div>
        </Box>
    );
}
